import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetSubmitBatchParticipationInvoice, submitBatchParticipationInvoice } from "./submit-batch-participation-invoice";

const initialState: ProcessingState = { processing: "idle" };

export const submitBatchParticipationInvoiceReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(submitBatchParticipationInvoice.fulfilled, () => ({ processing: "success" }));
  builder.addCase(submitBatchParticipationInvoice.pending, () => ({ processing: "pending" }));
  builder.addCase(submitBatchParticipationInvoice.rejected, () => ({ processing: "failed" }));
  builder.addCase(resetSubmitBatchParticipationInvoice, () => initialState);
});
